module.exports = __webpack_public_path__ + "static/media/how_to_5.352d8c95.svg";